export default "__VITE_ASSET__BUORF4eS__"